module.exports = __webpack_public_path__ + "static/managedinternetenvi-238f264798b57a176effa6193d01cbae.png";